import axios from 'axios'
import qs from 'qs'
import router from '../router'
import store from '@/store'//引入状态管理
import CryptoJS  from 'crypto-js'//哈希值
import { ElMessage, ElMessageBox } from 'element-plus'
import util from '@/api/util'
import { useRoute } from 'vue-router'
// let keyOne = randomString();
// console.log("keyOne",keyOne);

export const axiosBase = (params, axiosUrl) => {//前面页面传过来得参数跟url (timeout 参数作为超时时间动态设定)
  let user = localStorage.getItem('user');
  let visitorUser = localStorage.getItem('visitorUser')
  const route = useRoute()
  const skey = route?.params.skey || route?.query.skey
  if(user){
    user = JSON.parse(user)
  }
  if (visitorUser) {
    visitorUser = JSON.parse(visitorUser)
  }
  const temporaryToken = sessionStorage.getItem('temporaryToken')
  // openapi/getuserdesks 接口是中台过来直接读取登陆数据的不需要判断是否登陆 
  if(!user && !temporaryToken && !visitorUser && axiosUrl !== 'openapi/getuserdesks' && !skey){ 
    router.push({ name: 'login' });
    return false;
  }//报错提示  //进入登陆页
  console.log(util, 'utilutil')
  axios.defaults.baseURL = util.apiUrl()
  params = axiosUrl === '/api/deleteapproving' || axiosUrl === '/openapi/deleteknowledgefolder' || axiosUrl === '/openapi/deleteoptions' ||  axiosUrl === "/api/deleteuser" || axiosUrl === '/api/deleterole' || axiosUrl === '/api/deleteorganization' ? params : postPlainRequestParams(JSON.parse(JSON.stringify(params)))
  
  let arr = JSON.parse(JSON.stringify(store.state.postUrl));
  let urls = axiosUrl + '?' + qs.stringify(params);
  let len = arr.indexOf(urls);
  let nowDate = new Date();
  let keyOne;
  let differTime = localStorage.getItem('differTime');
  // 后端说本地测试直接用固定的hashkey，线上的用时间戳
  if(document.domain == "localhost"){
    keyOne = "khosidfopsdfsdowsjdsfsdf";
  }
  else{
    keyOne = Number(nowDate.getTime()) - Number(differTime) + '';
  }
  // 判断是否个人空间
  if (
    typeof router.history?.current.query.upaceid !== 'undefined' || (typeof router.history?.current.query.upace !== 'undefined' &&
    localStorage.getItem('upaceid'))
  ) {
    params.upaceid = router.history?.current.query.upaceid || localStorage.getItem('upaceid')
  }
  if (len !== -1) {
    return new Promise(() => {return false})
  } else {
    if (visitorUser && visitorUser.accesstoken) {
      params.accesstoken = visitorUser.accesstoken
    } else if(user&&user.accesstoken_external){
      //- 外链模式下使用的accesstoken
      params.accesstoken = user.accesstoken_external//参数加上accesstoken
    }else if(user&&user.accesstoken){
      //- 正常流程时使用的accesstoken
      params.accesstoken = user.accesstoken//参数加上accesstoken
    } else if (temporaryToken) {
      params.accesstoken = temporaryToken//参数加上accesstoken
    }
    params.hashkey = keyOne
    params.hashcode = jiami(params,keyOne)
    return axios.post(axiosUrl, //提交得url
        qs.stringify(params,{arrayFormat: 'brackets'})//参数解析成字符串格式上传
    ).then((res) => {
      //拿到结果了，删掉
      if(res.status===200){
        return res.data;
       }else{
        return ElMessageBox.confirm('网络开了点小差，请检查网络稍后登录！', '提示', {
          confirmButtonClass:'el-button--yeprimary',
          confirmButtonText: '好的',
          showCancelButton: false,
          type: 'warning'
        }).then(() => {
          return {code: 10009}
        })
       }
    })
    .catch((error) => {
      console.log('请求出错', error, JSON.stringify(error));
      // 针对晋江一中部分用户会用手机访问pc地址，然后报以下错误，因此屏蔽移动端端访问以下代码
      let userAgent = navigator?.userAgent
      let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
      if(isMobile) return false
      // 超时
      if (error.code === 'ECONNABORTED') {
        ElMessageBox.confirm('网络开了点小差，请检查网络稍后登录！', '提示', {
          confirmButtonClass:'el-button--yeprimary',
          confirmButtonText: '好的',
          showCancelButton: false,
          type: 'warning'
        })
      }
      if (error.code === 'Network Error' || !error.response) {
        ElMessage({
          showClose: true,
          message: '网络错误，请检查网络',
          type: 'error',
          duration: 2000
        })
      }
      //拿到结果了，删掉
    });
  }
};
function postPlainRequestParams (params) {
  const result = {}
  if (params) {
    for (const key of Object.keys(params)) {
      const value = params[key]
      if (value !== undefined) {
        result[key] = value && typeof value === 'object' ? JSON.stringify(value) : value
      }
    }
  }
  return result
}
function jiami(data,keyOne) {
    let value = getvalsign(data);
    let sha1_result = CryptoJS.HmacSHA1(value, keyOne).toString(CryptoJS.enc.Hex);
    return sha1_result;
}
function getvalsign(data) {
  var key = [];
  for (var o in data) {
      key.push(o);
  }
  key = key.sort();
  var str = "";
  for (var i = 0; i < key.length; i++) {
      var val = data[key[i]];
      if ((typeof val) == "object") {
        val = JSON.stringify(val);
      }
      str += key[i] + "=" + val + "&";
  }
  if(str.length > 0){
    str = str.substr(0, str.length -1);
  }
  return str;
}
// 随机生成字符串
// function randomString (len) {
//   len = len || 24;
//   var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
//   var maxPos = $chars.length;
//   var pwd = '';
//   for (var i = 0; i < len; i++) {
//     pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
//   }
//   return pwd;
// }